import { styled } from '@mui/material';
import { Stack } from '@mui/system';
import { BORDER_RADIUS_XXS } from 'shared';


export const ProgressBar = styled(Stack)(({ theme }) => ({
    height: 4,
    width: 139,
    borderRadius: BORDER_RADIUS_XXS,
    flexDirection: 'row',
    marginTop: '2px!important',
    marginBottom: '2px!important',
    backgroundColor: theme.themeColors.colorsProgressBarBg,
    '> div': {
      background: theme.themeColors.colorsProgressBarPlug,
      height: '100%',
    },
  }));
  